// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Z6eG","col":"styles_col__2KFRd","fulfillmentStatus":"styles_fulfillmentStatus__2gx-l","emailCol":"styles_emailCol__wkbmx"};